// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LzkoHSEh0IoF3vSVgHxl{align-items:center;height:32px;display:flex}.hFt8ApWYnAYRyIatsXKn{color:var(--content-primary-primary);font-size:13px;font-weight:400;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countLabelWrapper": `LzkoHSEh0IoF3vSVgHxl`,
	"countLabel": `hFt8ApWYnAYRyIatsXKn`
};
export default ___CSS_LOADER_EXPORT___;
